import { Spinner } from 'baseui/spinner';
import dynamic from 'next/dynamic';
import { StakingPoolTable } from 'structure/staking/containers/StakingPoolTable';
import { useStakingPoolList } from 'structure/staking/hooks/useStakingAPI';
import { ViewTypes } from 'structure/multi-asset-staking/types';
import {
  STAKING_VALUE_REFRESH_INTERVAL,
  useStakingPoolValues,
} from 'structure/staking/hooks/useStakingPoolValues';

const StakingCardView = dynamic(() => import('./StakingCardView'));

interface IStakingProjectsList {
  view: string;
}

export const StakingProjectsList = ({ view }: IStakingProjectsList) => {
  const stakingPoolList = useStakingPoolList({
    query: {
      refetchInterval: STAKING_VALUE_REFRESH_INTERVAL,
      staleTime: STAKING_VALUE_REFRESH_INTERVAL,
    },
  });
  const stakingPoolValues = useStakingPoolValues(stakingPoolList.data);

  if (stakingPoolList.isLoading) {
    return (
      <div className='m-auto w-full p-8'>
        <Spinner $size='14px' $borderWidth='3px' />
      </div>
    );
  }

  return (
    <>
      {ViewTypes.CARD_VIEW === view ? (
        <StakingCardView stakingPoolList={stakingPoolValues.data.pools} />
      ) : (
        <StakingPoolTable
          pools={stakingPoolValues.data.pools}
          enableExplore={true}
        />
      )}
    </>
  );
};
